import {Component} from "@angular/core";

@Component({
  selector: 'cm-header',
  templateUrl: './header.component.html',
  host: {'class': 'internal-header'}
})
export class HeaderComponent {

  constructor() {
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/header/header.component.ts